// Imported first by main.tsx: an invite link's token leaves the address bar before anything else reads it.
import { takeInviteFragment } from '@/lib/invites/takeInviteFragment'

takeInviteFragment()
